<template>
  <div>
    <!-- 分割线 -->
    <van-divider
      v-if="(showCommonBtn || showChangeBtn || showDesc) && !isCommonRecom"
    />
    <div
      :class="[
        'flex-between-center',
        'padding-left',
        { 'recom-item': isCommonRecom && showCommonBtn },
      ]"
    >
      <div
        v-if="showDesc"
        :class="isRed ? 'change-left-red' : 'change-left-black'"
        @click.stop="goExamUrl"
      >
        <div class="diagnose-icon"></div>
        <div class="text">{{ status.desc }}</div>
        <div v-if="isRed && status.url" class="arrow-exam-red"></div>
        <div v-if="!isRed && status.url" class="arrow-exam-black"></div>
      </div>
      <div></div>
      <div
        v-if="showCommonBtn"
        class="change-right"
        @click.stop="goChangeCoursePage"
      >
        <div>更换</div>
        <div class="arrow-icon-black"></div>
      </div>
      <div v-else-if="showChangeBtn">
        <div v-if="showSelectBtn" class="selected-btn">已选择</div>
        <div v-else class="select-btn" @click.stop="selectCourse">确认更换</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getCommonLog } from "../../changeCourse/utils/point";
import { getUrlParams } from "../../../utils/getUrlParams";

export default {
  inject: [
    "listType",
    "cardType",
    "tab_list_index",
    "package_info_index",
    "isAddPriceBuy", // 是否是加价购商品
    "isSimpleProduct",
    "change_info", // 加价购更换课程页面使用
    "parent",
    "switch_change", // 加价购是否支持更换课程
    "recomNotAddPriceBuyLen",
  ],
  props: {
    package_info: {
      // 为了跳转页面时获取必要参数
      type: Object,
      default: () => {
        return {};
      },
    },
    status: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    ...mapState({
      stateOriginParams: (state) => state.originParams,
      stateContCourseData: (state) => state.contCourseData,
    }),
    isRed() {
      return +this.status.id === 5;
    },
    // 状态ID （1、正常状态，2、已报满（无库存），3、已购买，4、已停售，5、需诊断后报名，6、无报名资格，10、诊断未通过，11、待开售）
    showDesc() {
      // 此处的样式只展示诊断状态
      return [5, 10].includes(+this.status?.id);
    },
    showCommonBtn() {
      const isAddPriceBuyShowCommonBtn =
        this.cardType === "recom" && this.isAddPriceBuy && this.switch_change; // 加价购  后台可配置是否支持更换课程
      const isRecomBuyShowCommonBtn =
        this.cardType === "recom" &&
        !this.isAddPriceBuy &&
        this.change_info?.change_product_ids?.length > 0; // 扩科  配置文件可配置是否支持更换课程
      return (
        this.listType === "common" &&
        ![6, 3].includes(+this.status?.id) &&
        (this.cardType !== "recom" ||
          isAddPriceBuyShowCommonBtn ||
          isRecomBuyShowCommonBtn)
      );
    },
    showChangeBtn() {
      return this.listType === "change" && [1, 5].includes(+this.status?.id);
    },
    showSelectBtn() {
      // 若选中的一级页课包id和二级页的课包id相同，则展示已选择按钮
      return +this.package_info.id === +this.stateOriginParams.package_info_id;
    },
    isCommonRecom() {
      // 首页的加价购商品列表，分割线在更换按钮的下面
      return (
        this.listType === "common" &&
        this.cardType === "recom" &&
        this.isAddPriceBuy &&
        this.recomNotAddPriceBuyLen === 0
      );
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["setOriginParams", "setForcedReload"]),
    // 跳转选择课程二级页
    goChangeCoursePage() {
      this.$xesLogger.clickMsg({
        params: {
          click_id: "click_fR8pbY5i",
          click_name:
            (this.cardType === "recom" ? "扩科" : "续联报") + "-更换点击",
          respos_type: this.cardType === "recom" ? 2 : 1,
          ...getCommonLog(this.package_info),
        },
      });
      this.$router.push({
        name: "changeCourse",
        query: {
          cardType: this.cardType, // 用来区分接口类型
          stuId: getUrlParams()?.stuId,
          isLoginFree: getUrlParams()?.isLoginFree,
        },
      });
      this.setParam();
      console.log("cardType", this.cardType);
      console.log("tab_list_index", this.tab_list_index);
      console.log("package_info_index", this.package_info_index);
    },
    // 换为本课
    selectCourse() {
      this.$xesLogger.clickMsg({
        params: {
          click_id: "click_vPBbz0LZ",
          click_name: "筛选页面-切换按钮点击",
          respos_type: this.cardType === "raw" ? 1 : 2,
          ...getCommonLog(this.package_info),
        },
      });
      this.$EventBus.$emit("selectCourse", this.package_info);
    },
    goExamUrl() {
      console.log("this.status.url-", this.status);
      if (this.status.url) {
        this.setForcedReload(true);
        window.location.href = this.status.url;
      }
    },
    // 仅用于获取match_class_id参数，用于判断原班推荐标签是否展示
    getMatchClassId() {
      // 若选择为 cnt_list[]. package_info第一个元素 match_class_id = title_info. cnt_class_id
      // 若选择为 cnt_list[]. package_info第二个元素 match_class_id = title_info. union_class_id
      console.log(
        "获取matchClassId----this.tab_list_index",
        this.tab_list_index
      );
      console.log("cardType", this.cardType);
      console.log("this.package_info_index", this.package_info_index);
      let match_class_id = "";
      if (this.cardType === "raw") {
        if (this.package_info_index === 0) {
          match_class_id =
            this.stateContCourseData?.cnt_list[this.tab_list_index].title_info
              .cnt_class_id;
        }
        if (this.package_info_index === 1) {
          match_class_id =
            this.stateContCourseData?.cnt_list[this.tab_list_index].title_info
              .union_class_id;
        }
      } else if (this.cardType === "recom") {
        match_class_id = -1;
      }
      console.log("match_class_id----", match_class_id);
      return match_class_id;
    },
    // 仅用于获取change_type参数，用于二级页更换课程接口
    getChangeType() {
      // 若更换cnt_list/[].package_info[0] && product_type = 100  change_type：1 原班续报
      // recom_list[].package_info[0] && product_type = 100  change_type：2 推荐续报
      // 否则其他情况  change_type：3 原班/推荐联报
      let change_type = -1;
      if (
        this.package_info.product_type == 100 &&
        this.cardType === "raw" &&
        this.package_info_index === 0
      ) {
        change_type = 1;
      } else if (
        this.package_info.product_type == 100 &&
        this.cardType === "recom" &&
        this.package_info_index === 0
      ) {
        change_type = 2;
      } else {
        change_type = 3;
      }
      return change_type;
    },
    // 仅用于获取cnt_course_ids参数，用于二级页更换课程接口
    getCntCourseIds() {
      // 一级页面所有cnt_list[].title_info.cnt_course_id的集合
      let cnt_course_ids =
        this.stateContCourseData?.cnt_list.map((item) => {
          return item.title_info.cnt_course_id;
        }) || [];
      return cnt_course_ids.join(",");
    },
    // 仅用于获取union_course_id参数，用于二级页更换课程接口
    getUnionCourseId() {
      // 一级页面所选课程的title_info. union_course_id 只有一个
      let union_course_id = "";
      const list =
        this.cardType === "raw"
          ? this.stateContCourseData?.cnt_list
          : this.stateContCourseData?.recom_list;
      union_course_id =
        list[this.tab_list_index]?.title_info?.union_course_id || "";
      return union_course_id;
    },
    // 获取二级页查询参数
    // 若当前title_info下的cnt_class_id和cnt_course_id能在package_info中完全找到匹配项
    // 那么传title_info下数据，这样是为了获取正确的原班数据
    getCourseIdAndClassId() {
      const param = {
        // 二级页查询参数
        course_id: this.package_info?.product_list[0]?.id, // 用于二级页查询
        class_id:
          this.package_info?.product_list[0]?.extra_info?.class_id || "", // 用于二级页查询
      };
      const list =
        this.cardType === "raw"
          ? this.stateContCourseData?.cnt_list
          : this.stateContCourseData?.recom_list;
      const title_info = list[this.tab_list_index]?.title_info;
      const findIndex = this.package_info.product_list.findIndex(
        (p) =>
          +p?.extra_info?.class_id === +title_info?.cnt_class_id &&
          +p?.id === +title_info?.cnt_course_id
      );
      if (findIndex > -1) {
        param.course_id = title_info?.cnt_course_id;
        param.class_id = title_info?.cnt_class_id;
      }
      return param;
    },
    // 是否存在用户组
    getIsGroup() {
      let is_group;
      const title_info =
        this.stateContCourseData?.cnt_list?.[this.tab_list_index]?.title_info;
      if (this.cardType === "raw") {
        if (this.package_info_index === 0) {
          is_group = title_info?.cnt_is_group;
        }
        if (this.package_info_index === 1) {
          is_group = title_info?.union_is_group;
        }
      }
      return is_group;
    },
    // 设置各项参数存于store
    setParam() {
      const data = {
        // 二级页查询参数
        ...this.getCourseIdAndClassId(),
        // 用于展示
        match_class_id: this.getMatchClassId(), // 展示原班课程
        package_info_id: this.package_info.id, // 展示已选择按钮
        // 更换课程接口参数
        product_id: this.package_info.product_id,
        origin_product_id: this.package_info.origin_product_id, // 更换商品之前的商品id
        product_type: this.package_info.product_type, // 用于更换课程/二级页查询
        change_type: this.getChangeType(),
        cnt_course_ids: this.getCntCourseIds(),
        union_course_id: this.getUnionCourseId(),
        // 用于替换原有课程
        tab_list_index: this.tab_list_index,
        package_info_index: this.package_info_index,
        selectType: this.package_info.selectType,
        change_info: this.change_info,
        parent: this.parent,
        is_group: this.getIsGroup(),
        isAddPriceBuy: this.isAddPriceBuy,
      };
      this.setOriginParams(data);
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.change-left-red,
.change-left-black {
  .flex-center-start;
  .text {
    margin: 0 5px;
    font-family: PingFang SC;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}
.recom-item {
  margin-top: 8px;
}
.change-left-red {
  .diagnose-icon {
    .connect-bg(14px, 14px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/diagnose-icon-red.png");
  }
  .text {
    color: #f93834;
  }
}
.change-left-black {
  .diagnose-icon {
    .connect-bg(14px, 14px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/diagnose-icon-black.png");
  }
  .text {
    color: #333;
  }
}
.arrow-exam-red {
  .connect-bg(16px, 16px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/arrow-right-red.png");
}
.arrow-exam-black {
  .connect-bg(16px, 16px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/arrow-right-black.png");
}
.change-right {
  .flex-center-end;
  color: #333;
  text-align: right;
  font-family: PingFang SC;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .arrow-icon-black {
    margin-left: 2px;
    .connect-bg(12px, 12px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/arrow-right-black.png");
  }
}
.select-btn {
  .flex-center-center;
  width: 84px;
  height: 28px;
  color: #fff;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 500;
  background-color: #f93834;
  border-radius: 16px;
}
.selected-btn {
  .select-btn;
  color: #adadad;
  font-weight: 500;
  background-color: rgba(153, 153, 153, 0.1);
}
/deep/ .van-divider {
  margin-top: 12px;
  margin-bottom: 12px;
}
.padding-left {
  padding-left: 4px;
}
</style>
